export default {"src":"/evde-internet/_next/static/media/red-phone.c60f0ef9.svg","height":36,"width":36};